// ----------------------------------------------------------------------------
// トップの大タブ
// ----------------------------------------------------------------------------

$(function() {

if ( $('body').hasClass('home') ) {
  var $tabTableItems = $('.tab-table__item'); // 大タブ内のすべてのタブ

  $tabTableItems.on('click', function() {
    var $allTabs = $('.tabby-top .swiper-slide'); // 小タブ内のすべてのタブ
    var $firstOfTabType = $('.tabby-top .swiper-slide[data-type="' + $(this).data('tab-link') + '"]').first(); // クリックしたタブの種類の最初の項目

    // 小タブの位置によって違うところまでスライドする条件分
    if ($allTabs.length - $allTabs.index($firstOfTabType) < 5) { // クリックした種類の小タブが最後から５個に入っていたら
      tabbyBottom.slideTo( $allTabs.index($firstOfTabType) ); // コンテンツタブを選択し（小タブにも関連あるから「active」となる）
      tabbyTop.slideTo( $allTabs.length ); // 小タブの最後の項目までスクロールする
    } else {
      tabbyBottom.slideTo( $allTabs.index($firstOfTabType) );
    }

    $tabTableItems.each(function(index, tab) {
      if ($(tab).hasClass('js-type-visible')) {
        $(tab).removeClass('js-type-visible')
      }
    });

    // クリックされてない大タブから「js-」クラスと取り去って
    // クリックされた大タブに適用「js-」クラスをつける
    $('.tab-table')
      .removeClass(function(index, css) {
        return (css.match(/js-\S+/g) || []).join(' ');
      })
      .addClass('js-' + $(this).data('tab-link'));
    
    $(this).addClass('js-type-visible');
  });

  var today = new Date();
  var daySpan = 7;

  // 小タブに入っている最初の一件の記事項目
  var $allArticleItems = $('.swiper-slide.append.row article:first-child');
  function pad(n){return ('0' + n).slice(-2);}
  var latestDates = {};

  $allArticleItems.each(function(index, item) {
    var capturedDate = new Date($(item).data('date'));
    var category = $(item).closest('.swiper-slide').data('type');

    if (category === 'event') category = 'events'; // JSONに登録されたカテゴリー名は複数形ではないため

      if (numDaysBetween(today, capturedDate) < daySpan) {
        if (!latestDates[category]) {
          latestDates[category] = capturedDate;
        } else if (capturedDate.getTime() > latestDates[category].getTime()) {
          latestDates[category] = capturedDate;
        } else {
          return;
        }

        $('.tab-table__item[data-tab-link=' + category + ']')
          .addClass('tab-table__item--new')
          .attr(
            'data-date',
            (latestDates[category].getMonth() + 1) + '月' + // JSの月は０から始まるため１を加える必要ある
            latestDates[category].getDate() + '日' + 'UP'
          );
      } // numDaysBetween
  }); // .each
}; // body.home

}); // jQuery ready